import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { donationInfo } from "../data/siteContent";
import styles from "./DonationsSection.module.css";

const DonationsSection = () => (
  <div className={styles.container} data-aos="fade-up" id="donations">
    <Container className="py-5 text-center">
      <h2 className={`mb-4 ${styles.title}`}>{donationInfo.title}</h2>
      <p className={`mb-4 ${styles.description}`}>{donationInfo.description}</p>
      <Row className="justify-content-center">
        <Col md={4} className="mb-4">
          <div className={styles.cashAppCard}>
            <h4 className={styles.cashAppTitle}>Cash App</h4>
            <p className={styles.cashAppHandle}>
              <strong>{donationInfo.cashApp.handle}</strong>
            </p>
            <img
              className={styles.qrCode}
              src={donationInfo.cashApp.qrCode}
              alt="Cash App QR Code"
            />
          </div>
        </Col>
      </Row>
      <p className={styles.note}>{donationInfo.additionalNote}</p>
    </Container>
  </div>
);

export default DonationsSection;
